var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A7143B76-01BD-44C0-8680-6138E5DEC811") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 3.92399789 0 3.92399789 5.0908 0 5.0908"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Form",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop_Form-press",
    transform: "translate(-191.000000, -904.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(191.467393, 904.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(9.094789, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.01411786,5.0908 C0.832117861,5.0908 0.647117861,5.0418 0.481117861,4.9388 C0.00411786091,4.6438 -0.142882139,4.0188 0.152117861,3.5418 L2.04611786,0.4808 C2.34011786,0.0048 2.96611786,-0.1432 3.44311786,0.1518 C3.91911786,0.4468 4.06711786,1.0718 3.77211786,1.5488 L1.87811786,4.6098 C1.68611786,4.9198 1.35411786,5.0908 1.01411786,5.0908",
    id: "Fill-10",
    fill: "#3669C9",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.48040717,15.803 C3.29840717,15.803 3.11340717,15.754 2.94740717,15.651 C2.47040717,15.356 2.32340717,14.731 2.61840717,14.254 L4.51240717,11.193 C4.80740717,10.717 5.43340717,10.569 5.90940717,10.864 C6.38540717,11.159 6.53340717,11.784 6.23840717,12.261 L4.34440717,15.322 C4.15240717,15.632 3.82040717,15.803 3.48040717,15.803",
    id: "Fill-13",
    fill: "#3669C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00400717,6.5332 C3.81700717,6.5332 3.62800717,6.4812 3.45900717,6.3742 L0.469007169,4.4672 C-0.00299283085,4.1662 -0.141992831,3.5382 0.159007169,3.0652 C0.461007169,2.5932 1.08800717,2.4542 1.56100717,2.7552 L4.55100717,4.6622 C5.02300717,4.9632 5.16200717,5.5912 4.86100717,6.0642 C4.66700717,6.3672 4.33900717,6.5332 4.00400717,6.5332",
    id: "Fill-15",
    fill: "#3669C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4690072,13.2066 C14.2820072,13.2066 14.0930072,13.1546 13.9240072,13.0476 L10.9340072,11.1406 C10.4620072,10.8396 10.3230072,10.2116 10.6240072,9.7386 C10.9260072,9.2666 11.5530072,9.1276 12.0260072,9.4286 L15.0160072,11.3356 C15.4880072,11.6366 15.6270072,12.2646 15.3260072,12.7376 C15.1320072,13.0406 14.8040072,13.2066 14.4690072,13.2066",
    id: "Fill-17",
    fill: "#3669C9"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.58b2102546361e4feb668e795384f115.svg";
export { ForwardRef as ReactComponent };